export default __webpack_public_path__ + "static/media/solarp2.42d35a75.jpg";